module.exports = __webpack_public_path__ + "static/img/recommend.70a02c11.png";